
import SidebarSkeleton from '../../../dashboard2/dashboard-aside-skeleton/component';
import HotelCardSkeleton from '../../../dashboard/hotel-card-skeleton/component';

import './style.scss';

export function SkeletonResult() {
  return (
    <section>
      <div className="container">
        <div className="row pt-2 px-15">
          <SidebarSkeleton />
          <div className="col-12 col-xl-8 col-xxl-9">
            <div className="vstack gap-4">
              {[...Array(3)].map((_, index) => (
                <HotelCardSkeleton key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
